import React from 'react';
import { cn } from '../../../utils/classnames';
import ClientStatusBadge from '../../../components/ui/badges/ClientStatusBadge';
import DynamicActionButton from '../../../components/ui/buttons/DynamicActionButton';

const TeamClientRow = ({ client, index }) => {
  const isEven = index % 2 === 0;
  const bgClass = isEven ? 'bg-white' : 'bg-transparent';

  return (
    <tr className="text-blueDarker">
      <td className={cn('pl-4 py-4 m-1 rounded-l-xl', bgClass)}>
        <ClientStatusBadge status={client.status} tStatus={client.tStatus} />
      </td>

      <td className={cn('text-lg font-semibold py-4', bgClass)}>
        <div className="flex items-center gap-2">
          <div className="truncate whitespace-nowrap" title={client.name}>
            {client.name}
          </div>
        </div>
      </td>

      <td className={cn('pr-4 text-base', bgClass)}>
        <div className="truncate whitespace-nowrap" title={client.planner}>
          {client.planner}
        </div>
      </td>

      <td className={cn('pl-6 text-base', bgClass)}>
        <div className="truncate whitespace-nowrap" title={client.updatedAt}>
          {client.updatedAt}
        </div>
      </td>

      <td className={cn('pr-4 rounded-r-xl', bgClass)} style={{ width: '380px', minWidth: '360px' }}>
        <div className="flex gap-2 justify-end items-center flex-nowrap">
          <a href={`/app/planner/client/${client.id}/profile?from=commercial.team`}>
            <DynamicActionButton state={'simple'}>DOCUMENTAÇÃO COMPLETA</DynamicActionButton>
          </a>
          <a href={`/app/planner/client/${client.id}/dashboard?from=commercial.team`}>
            <DynamicActionButton state={'default'}>MAIS INFORMAÇÕES</DynamicActionButton>
          </a>
        </div>
      </td>
    </tr>
  );
};

export default TeamClientRow;
